import React from "react";

import Main from "./Main";
import "./App.css";
import { motion } from "framer-motion";
import MouseFollower from "./Components/MouseFollower";
import { CursorContextProvider } from "./utils/useCursor";
import { Leva } from "leva";

function App() {
  // const theme = useContext(ThemeContext)

  // const darkMode = theme.state.darkMode

  return (
    <CursorContextProvider>
      <motion.div className="App">
        <Main />
        <Leva hidden />
        <MouseFollower />
      </motion.div>
    </CursorContextProvider>
  );
}

export default App;
